module.exports = __webpack_public_path__ + "static/media/climbing-with-rope.839280ce.png";